<template>
  <div class="channel">
    <div class="hpnew bg-circles">
      <div class="header" id="top">
        <div class="hdr_wrap">
          <div class="topbar">
            <amio-menu></amio-menu>
          </div>

          <div class="clear"></div>
        </div>

        <div class="channel_hdr">
          <div class="bgimg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1660 652" width="1660px" height="652px">
              <path class="hdr"
                    d="M5.73,578.63A50.1,50.1,0,0,0,50.12,652c0.81,0,1.62,0,2.43-.06l2.71-.2c4.5-.37,9.3-1,14.47-1.79C174.63,633,1308.5,445.19,1308.5,445.19s156.84-11,220.78-148.82C1583,180.45,1642.45,49,1660,10.12V0H318.78Z"
                    transform="translate(0 0)"/>
            </svg>

            <div class="minus_cont">
              <div class="circle_wr">
                <div class="circle_logo">
                  <slot name="logo"></slot>
                </div>
              </div>

              <div class="ch_headline">
                <h1 class="text-white">{{title}}</h1>

                <span>{{subTitle}}</span>

                <div class="btns">
                  <a :href="contactLink" class="action-btn">
                    <div class="connect">Request Demo</div>
                  </a>
                  <a target="_blank" :href="documentationLink" class="text">Documentation</a>
                  <template v-if="apiRefLink">
                    |
                    <a target="_blank" :href="apiRefLink" class="text">
                      API Reference
                    </a>
                  </template>
                </div>
              </div>
            </div>
            <div class="ch_submenu">
              <a target="_blank" :href="webLink">Website</a>
              |
              <a target="_blank" :href="supportLink">Support</a>
              |
              <a target="_blank" :href="licenseLink">License Agreement</a>
            </div>
          </div>
        </div>
      </div>

      <div class="phone-header">
        <div class="phone_crop">
          <div class="hdr_obal">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1110 583" width="1110px" height="583px">
              <defs></defs>
              <path class="hdr" d="M0,583L990.67,448.41s92-12.66,119.33-113.93V0H0V583Z"/>
            </svg>
          </div>

        </div>
        <div class="ch_headline">
          <h1>{{title}}</h1>

          <span>{{subTitle}}</span>
        </div>

        <div class="ch_headline sub">
          <div class="btns">
            <a :href="contactLink" class="action-btn">
              <div class="connect">Request Demo</div>
            </a><br>
            <a target="_blank" :href="documentationLink" class="text">Documentation</a>
            <template v-if="apiRefLink">
              |
              <a target="_blank" :href="apiRefLink" class="text">API Reference</a>
            </template>
          </div>

          <div class="circle_wr">
            <div class="circle_logo">
              <slot name="logo"></slot>
            </div>
          </div>
        </div>
        <div class="pch_submenu">
          <a target="_blank" :href="webLink" class="button">
            Website
          </a>
          <a target="_blank" :href="supportLink" class="button">
            Support
          </a>
          <a target="_blank" :href="licenseLink" class="button">
            License Agreement
          </a>
        </div>
      </div>

      <div class="wrapper my-5 pb-5">
        <slot name="content"></slot>
      </div>

      <amio-footer></amio-footer>
    </div>
  </div>
</template>

<script>
  import AmioMenu from '@/components/common/AmioMenu'
  import AmioFooter from '@/components/common/AmioFooter'

  export default {
    components: {
      AmioMenu,
      AmioFooter
    },
    props: {
      title: {
        type: String,
        required: true
      },
      subTitle: {
        type: String,
        required: true
      },
      contactLink: {
        type: String,
        required: true
      },
      documentationLink: {
        type: String,
        required: true
      },
      apiRefLink: String,
      webLink: {
        type: String,
        required: true
      },
      supportLink: {
        type: String,
        required: true
      },
      licenseLink: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/css/channel';
</style>
